"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ALL: null,
  AVIATION: null,
  BUSINESS_SERVICE: null,
  CONSUMER_SERVICE: null,
  COMMUNICATIONS: null,
  CONSULTING: null,
  EVENT_SERVICES: null,
  FINANCIAL_SERVICES: null,
  HEALTHCARE: null,
  LEGAL_SERVICES: null,
  MARKETING_AGENCY: null,
  MEDIA: null,
  MANUFACTURING: null,
  RECRUITING: null,
  SOFTWARE: null,
  TECHNOLOGY: null,
  TRAVEL: null,
  EDUCATION: null,
  NONPROFIT: null,
  HARDWARE: null,
  COMMERCE: null,
  PROFESSIONAL_SERVICE: null,
  RESTAURANT: null,
  ENTERTAINMENT: null,
  REAL_ESTATE: null,
  OTHER_INDUSTRY: null
});

exports.default = _default;
module.exports = exports.default;